export default __webpack_public_path__ + "static/media/EAST3140.34I-40854_-24159_0.0c857ac3.jpg";